import { action, computed } from 'mobx';
import Store from '~/glm/models/store';
import GdsApi from '~/glm/utils/gds-api';

export default class GdsModel extends Store {
  dirty = false;

  @computed
  get apiParams() {
    throw new Error(`${this.constructor.name} must implement apiParams method`);
  }

  @action
  setProp(key, value, dirty = true) {
    super.setProp(key, value);
    this.dirty = dirty;
  }

  @computed
  get isNew() {
    return !this.id;
  }

  @action
  post() {
    const originalParams = this.copyCurrentProps(this.apiParams);
    return GdsApi.post(this.apiEndpoint, this.apiParams)
      .then(jsonParams => {
        this.dirty = false;
        this.setProps(jsonParams);
        if (this.collection) {
          this.collection.add(this);
        }
        return Promise.resolve(jsonParams);
      })
      .catch(() => {
        this.setProp(originalParams);
        return Promise.reject();
      });
  }

  @action
  patch(params) {
    const originalParams = this.copyCurrentProps(params);
    return GdsApi.patch(this.apiEndpoint, params)
      .then(jsonParams => {
        this.dirty = false;
        this.setProps(jsonParams);
        return Promise.resolve(jsonParams);
      })
      .catch(error => {
        this.setProps(originalParams);
        return Promise.reject(error);
      });
  }

  @action
  put(params) {
    const originalParams = this.copyCurrentProps(params);
    return GdsApi.put(this.apiEndpoint, params)
      .then(jsonParams => {
        this.dirty = false;
        this.setProps(jsonParams);
        return Promise.resolve(jsonParams);
      })
      .catch(error => {
        this.setProps(originalParams);
        return Promise.reject(error);
      });
  }

  @action
  delete() {
    if (this.collection) {
      this.collection.remove(this);
    }
    const originalParams = this.copyCurrentProps(this.apiParams);
    return GdsApi.delete(this.apiEndpoint, this.apiParams)
      .then(() => Promise.resolve())
      .catch(() => {
        this.setProps(originalParams);
        return Promise.reject();
      });
  }

  copyCurrentProps(props) {
    const prevProps = {};
    Object.keys(props).forEach(key => {
      prevProps[key] = this[key];
    });
    return prevProps;
  }
}
